import { useParams, useNavigate } from 'react-router-dom';
import { AdminOrderDetail } from './AdminOrderDetail';

/**
 * Route wrapper so a deep link (e.g. the Overview "latest orders" list linking
 * to /control-7f3a9b2c/orders/:id) can open the order-detail panel. The panel
 * itself is a props-driven modal (orderId + onClose) reused from the Orders
 * list; closing returns to the full Orders & delivery view.
 */
export default function AdminOrderDetailRoute() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  if (!id) return null;
  return <AdminOrderDetail orderId={id} onClose={() => navigate('/control-7f3a9b2c/orders')} />;
}
